import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              读者心声
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              来自韩国漫画爱好者的真实评价，听听他们怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {commentItems.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        (e.currentTarget as HTMLElement).style.display = 'none';
                      }}
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                    <div className="text-xs text-foreground-400">{comment.date}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {comment.content}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {comment.likes}
                  </span>
                  <span className="inline-flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}